<template>
  <component
    :is="cellElement"
    class="sf-table-header-cell"
    :class="cellClass"
    :data-testid="`sf-header-${headerIndex}`"
  >
    <span
      :class="cellTextClass"
      :style="cellLinkStyle"
      data-testid="sf-header-cell-text"
    >
      <slot />
    </span>
    <i
      v-if="headerId === sortBy && sortable"
      class="sf-c-primary"
      data-testid="sf-header-cell-arrow"
      :class="sortingArrow"
    />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { tableSortDirections } from './../constants'

interface Props {
  align?: 'left' | 'right'
  headerId: string
  headerIndex: number
  maxHeaderCellWidth?: number
  sortable: boolean
  sortBy: string
  sortDirection: string
}

const props = withDefaults(defineProps<Props>(), {
  align: 'left',
  maxHeaderCellWidth: undefined,
  sortable: true,
})

const cellElement = computed(() => {
  return props.sortable ? 'a' : 'span'
})

const cellClass = computed(() => {
  return {
    'sf-a': props.sortable,
    'sf-table-header-cell--align-right': props.align === 'right',
  }
})

const cellTextClass = computed(() => {
  return {
    'sf-inline-block': !!props.maxHeaderCellWidth,
    'sf-truncate': !!props.maxHeaderCellWidth,
    'sf-noscroll': !!props.maxHeaderCellWidth,
  }
})

const cellLinkStyle = computed(() => {
  return props.maxHeaderCellWidth
    ? {
        maxWidth: `${props.maxHeaderCellWidth - 20}px`,
      }
    : {}
})

const sortingArrow = computed(() => {
  return {
    'fa fa-arrow-up': props.sortDirection === tableSortDirections.ASC,
    'fa fa-arrow-down': props.sortDirection === tableSortDirections.DESC,
    'sf-inline-block': !!props.maxHeaderCellWidth,
  }
})
</script>

<style lang="scss">
.sf-table-header-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  user-select: none;

  &--align-right {
    justify-content: right;
  }
}
</style>
